const LEARNER_ROUTE_PREFIXES = ['/my', '/playground', '/aiq-test'] as const

export function isLearnerRoutePath(pathname: string): boolean {
  return LEARNER_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
}
